export function formatPercentage(input: string) {
  let inputAsNumber = parseInt(("" + input).replace(/\D/g, ""));
  if (inputAsNumber < 0 || inputAsNumber > 10000) return "0,00";

  let pieces = (inputAsNumber / 100).toFixed(2).split(/[,.]/);

  if (pieces.length < 2) return "0," + pieces[1].padEnd(2, "0");
  return pieces[0].padStart(2, "0") + "," + pieces[1].padEnd(2, "0");
};